import { ReactElement } from 'react';
import LadleSlagModelVideoPlayer from './LadleSlagModelVideoPlayer';
import WhyUseLSM from './WhyUseLSM';
import HowLSMWorks from './HowLSMWorks';
import WhatIsLSM from './WhatIsLSM';
import ScientificArticles from './ScientificArticles';

const Main = (): ReactElement => {
  return (
    <main>
      <LadleSlagModelVideoPlayer />
      <WhyUseLSM />
      <HowLSMWorks />
      <WhatIsLSM />
      <ScientificArticles />
    </main>
  );
};

export default Main;
